export const chatdeskCannedReplyVariables = [
  { key: 'memberName', label: '會員姓名' },
  { key: 'memberPhone', label: '會員電話' },
  { key: 'memberEmail', label: '會員 Email' },
  { key: 'memberTier', label: '會員等級' },
  { key: 'availablePoints', label: '可用點數' },
  { key: 'latestOrderNumber', label: '最近訂單編號' }
];

function variableValues(memberContext = {}) {
  const member = memberContext?.member || {};
  const latestOrder = memberContext?.recentOrders?.[0] || {};
  return {
    memberName: member.name,
    memberPhone: member.phone,
    memberEmail: member.email,
    memberTier: member.memberTier,
    availablePoints: memberContext?.pointsSummary?.availablePoints,
    latestOrderNumber: latestOrder.orderNumber
  };
}

export function resolveCannedReplyContent(content, memberContext) {
  const values = variableValues(memberContext);
  return String(content || '').replace(/\{\{([A-Za-z][A-Za-z0-9]*)\}\}/g, (token, key) => {
    const value = values[key];
    return value === undefined || value === null || value === '' ? token : String(value);
  });
}

export function toComposerPayload(cannedReply, memberContext) {
  if (cannedReply?.messageType === 'line_template') {
    return {
      draft: '',
      pendingMedia: {
        messageType: 'line_template',
        cannedReplyId: cannedReply.id,
        fileName: cannedReply.lineMsgTemplateSnapshot?.name || cannedReply.title
      }
    };
  }

  const draft = resolveCannedReplyContent(cannedReply?.content, memberContext);
  const pendingMedia = cannedReply?.messageType === 'text'
    ? null
    : {
        messageType: cannedReply.messageType,
        mediaUrl: cannedReply.mediaUrl,
        fileName: cannedReply.fileName,
        mimeType: cannedReply.mimeType,
        fileSize: cannedReply.fileSize
      };

  return { draft, pendingMedia };
}
